import { Component, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClearSystemDataService } from '../../service/http-clear-system-data.service';

@Component({
	selector: 'app-clear-all-data-modal',
	standalone: false,
	templateUrl: './clear-all-data-modal.component.html',
	styleUrl: './clear-all-data-modal.component.scss'
})
export class ClearAllDataModalComponent implements OnDestroy {
	formGroup!: FormGroup;
	clearing = false;
	cleared = false;
	message?: string;
	progress = 0;
	private progressInterval?: ReturnType<typeof setInterval>;

	constructor(private fb: FormBuilder, private modelRef: NgbActiveModal, private service: HttpClearSystemDataService) { }

	ngOnInit() {
		this.formGroup = this.fb.group({
			otp: ['', [Validators.required]]
		});
	}

	ngOnDestroy() {
		this.clearProgressInterval();
	}

	private clearProgressInterval() {
		if (this.progressInterval) {
			clearInterval(this.progressInterval);
			this.progressInterval = undefined;
		}
	}

	private startProgress(onComplete: () => void) {
		this.progress = 0;
		const duration = 60000; // 1 minute
		const intervalMs = 100; // Update every 100ms
		const increment = 100 / (duration / intervalMs);

		this.progressInterval = setInterval(() => {
			this.progress += increment;
			if (this.progress >= 100) {
				this.progress = 100;
				this.clearProgressInterval();
				onComplete();
				window.location.reload();
			}
		}, intervalMs);
	}

	getFormControl(name: string): AbstractControl {
		return this.formGroup.get(name)!;
	}

	controlInvalid(name: string): boolean {
		const ctrl = this.formGroup.get(name);
		return !!ctrl && ctrl.invalid && (ctrl.dirty || ctrl.touched);
	}

	getError(name: string): string | null {
		const ctrl = this.formGroup.get(name);
		if (!ctrl || !ctrl.errors) return null;

		if (ctrl.errors['required']) return 'This field is required';
		if (ctrl.errors['invalid']) return 'Invalid';

		return 'Invalid value';
	}

	onSubmit() {
		if (this.formGroup.valid) {
			this.clearing = true;
			this.message = undefined;

			this.service.execute(this.formGroup.get('otp')!.value).subscribe({
				next: (result) => {
					if (result.success) {
						this.message = 'Clearing data...';
						this.startProgress(() => {
							this.clearing = false;
							this.message = result.message;
							this.cleared = true;
						});
					} else {
						this.clearing = false;
						this.message = result.message;
					}
				},
				error: (err) => {
					this.clearing = false;
					this.message = "Failed";
				}
			});
		}
	}
}
